import React, {
  createContext,
  ReactNode,
  useContext,
  useEffect,
  useState,
} from 'react';
import { getCookie } from '../utils/cookie-handler';
import { Logger } from '../utils/logger';

interface CookiesPermissionContextProps {
  isCookiesDisabled: boolean;
  //isCookiesPermissionDiclined: boolean;
  checkCookiesPermission: () => Promise<boolean>;
}

const CookiesPermissionContext = createContext<
  CookiesPermissionContextProps | undefined
>(undefined);

export const CookiesPermissionProvider: React.FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [isCookiesDisabled, setIsCookiesDisabled] = useState<boolean>(false);
  //const [isCookiesPermissionDiclined, setIsCookiesPermissionDiclined] = useState<boolean>(false);

  const testCookiePermission = React.useCallback(() => {
    const timestamp = new Date().getTime().toString();
    document.cookie =
      'acsb_test_cookie=' + timestamp + '; path=/; Secure; SameSite=None';
    Logger.log('--- Checking Cookies');
    const testCookie = getCookie('acsb_test_cookie');
    if (!testCookie || testCookie !== timestamp) {
      Logger.log('Cookies are disabled', testCookie, timestamp);
      setIsCookiesDisabled(true);
    }
  }, []);

  useEffect(() => {
    testCookiePermission();
  }, [testCookiePermission]);

  const checkCookiesPermission = async (): Promise<boolean> => {
    if (isCookiesDisabled) {
      try {
        await document.requestStorageAccess();
        testCookiePermission();
        //setIsCookiesPermissionDiclined(false);
        return true;
      } catch (error) {
        Logger.log('Cookies -- Storage access denied.');
        //setIsCookiesPermissionDiclined(true);
        return false;
      }
    }
    return true;
  };

  return (
    <CookiesPermissionContext.Provider
      value={{
        isCookiesDisabled,
        //isCookiesPermissionDiclined,
        checkCookiesPermission,
      }}
    >
      {children}
    </CookiesPermissionContext.Provider>
  );
};

export const useCookiesPermission = (): CookiesPermissionContextProps => {
  const context = useContext(CookiesPermissionContext);
  if (!context) {
    throw new Error(
      'useCookiesPermission must be used within a CookiesPermissionProvider',
    );
  }
  return context;
};
